<itl-wizard-page
  class="wizard-page"
  [isSinglePage]="true"
  [pageTitleTransPath]="'patient.list.filter.title'"
  [pageIsValid]="form.dirty === true"
  (doneClicked)="done()"
  (cancelClicked)="cancel()"
>
  <div class="page">
    <div class="content">
      <itl-section [title]="'patient.list.filter.fieldnurse' | translate" [isDetail]="false" *ngIf="!isMyPatientList">
        <itl-autocomplete
          [ngClass]="{ 'filter-active-icon': form.controls.fieldNurseId.value }"
          [placeholder]="'patient.list.filter.searchFieldnurse_placeholder' | translate"
          type="fieldNurse"
          [title]="'patient.list.filter.searchFieldnurse' | translate"
          icon="alberta-fieldnurse"
          [(control)]="form.controls.fieldNurseId"
          [selected]="form.controls.fieldNurseId.value"
        >
        </itl-autocomplete>
      </itl-section>
      <itl-section [title]="'patient.list.filter.nursinghome' | translate" [isDetail]="false">
        <itl-autocomplete
          [ngClass]="{ 'filter-active-icon': form.controls.nursingHomeId.value }"
          [placeholder]="'patient.list.filter.searchNursinghome_placeholder' | translate"
          [type]="'nursingHome'"
          icon="alberta-nursinghome"
          [title]="'patient.list.filter.searchNursinghome' | translate"
          [(control)]="form.controls.nursingHomeId"
          [selected]="form.controls.nursingHomeId.value"
        >
        </itl-autocomplete>
        <itl-selection
          *ngIf="subunitSelectionItems.length > 0"
          [ngClass]="{ 'filter-active-icon': form.controls.subunitId.value }"
          [disabled]="subunitSelectionItems.length === 0"
          [formControl]="form.controls.subunitId"
          [title]="'patient.list.filter.selectSubunit' | translate"
          [placeholder]="'patient.list.filter.selectSubunit_placeholder' | translate"
          [values]="subunitSelectionItems"
          icon="alberta-subunit"
        ></itl-selection>
      </itl-section>
      <itl-section [title]="'patient.list.filter.nursingService' | translate" [isDetail]="false">
        <itl-autocomplete
          [ngClass]="{ 'filter-active-icon': form.controls.nursingServiceId.value }"
          [placeholder]="'patient.list.filter.searchNursingService_placeholder' | translate"
          [type]="'nursingService'"
          icon="alberta-nursingService"
          [title]="'patient.list.filter.searchNursingService' | translate"
          [(control)]="form.controls.nursingServiceId"
          [selected]="form.controls.nursingServiceId.value"
        >
        </itl-autocomplete>
      </itl-section>
      <itl-section [title]="'patient.list.filter.lastVisit' | translate" [isDetail]="false" *ngIf="isMyPatientList">
        <itl-selection
          [title]="'patient.list.filter.lastVisit' | translate"
          [(ngModel)]="lastVisitValue"
          [noDeleteButton]="true"
          [values]="lastVisitTypes"
          [formControl]="form.controls.lastVisit"
        >
        </itl-selection>
      </itl-section>
      <itl-section [title]="'patient.list.filter.therapyTitle' | translate" [isDetail]="false" *ngIf="isMyPatientList">
        <itl-selection
          [formControl]="form.controls.therapyId"
          [title]="'patient.list.filter.therapy' | translate"
          [values]="therapySelectionItems"
        >
        </itl-selection>
        <itl-selection
          *ngIf="therapyTypeSelectionItems.length > 0"
          [formControl]="form.controls.therapyTypeId"
          [disabled]="therapyTypeSelectionItems.length === 0"
          [title]="'patient.list.filter.therapyType' | translate"
          [values]="therapyTypeSelectionItems"
        >
        </itl-selection>
      </itl-section>
      <itl-section [title]="'patient.list.filter.payer' | translate" [isDetail]="false" *ngIf="isMyPatientList">
        <itl-selection
          [formControl]="form.controls.payerType"
          [title]="'patient.edit.payer_type' | translate"
          [values]="payerTypes"
          icon="alberta-payer"
        >
        </itl-selection>

        <itl-autocomplete
          *ngIf="
            form.controls.payerType.value === PayerType.Statutory || form.controls.payerType.value === PayerType.Private
          "
          [(control)]="form.controls.payerId"
          [selected]="form.controls.payerId.value"
          [restriction]="payerRestriction"
          [type]="'payer'"
          icon="alberta-payer"
          [title]="'patient.edit.payer' | translate"
        >
        </itl-autocomplete>
      </itl-section>
      <itl-toggle
        [formControl]="form.controls.showDisabledPatients"
        [title]="'patient.list.filter.showDeadPatients' | translate"
      ></itl-toggle>
    </div>
    <div class="button-container">
      <itl-button class="deleteButton" expand="block" (click)="resetFilter()">
        <ion-icon name="alberta-reset"></ion-icon>
        {{ 'patient.list.filter.resetFilter' | translate }}
      </itl-button>
    </div>
  </div>
</itl-wizard-page>
